import { render, staticRenderFns } from "./PlanFactStatusBadge.vue?vue&type=template&id=161360c8&"
import script from "./PlanFactStatusBadge.vue?vue&type=script&lang=js&"
export * from "./PlanFactStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports